// src/redux/actions/cityActions.js
import {
    FETCH_GETCOMPANIES_REQUEST,
    FETCH_GETCOMPANIES_SUCCESS,
    FETCH_GETCOMPANIES_FAILURE,
    SET_SELECTED_GETCOMPANIES,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchCompanyData = (searchTerm = '') => async (dispatch) => {
    dispatch({ type: FETCH_GETCOMPANIES_REQUEST });
  
    try {
      const response = await axios.get(`/MasterData/GetRegdCompaniesDDL?Search=${searchTerm}`);
      // console.log("GETCOMPANIES :" , response );
      
      let getcompaniesList =response.data.responseData.map((val)=>{
        return{
          value:val.id,
          label:val.name,
          tag:val.tagID
        }
    })
      dispatch({
        type: FETCH_GETCOMPANIES_SUCCESS,
        payload: getcompaniesList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_GETCOMPANIES_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const selectGetCompanies = (getcompaniesId) => ({
    type: SET_SELECTED_GETCOMPANIES,
    payload: getcompaniesId,
  });
  